<template>
  <section class="px-64 mx-auto py-12">
    <h1 class="text-3xl font-bold mb-6">Paiement sécurisé</h1>
    <div class="bg-white rounded-lg shadow p-6 mb-6">
      <div class="mb-4">
        <div class="font-bold mb-1">Montant à régler :</div>
        <div class="text-2xl text-primary font-bold">{{ total }} € TTC</div>
        <div class="text-sm text-gray-500">{{ abonnement.nom }} - {{ abonnement.duree === 'year' ? 'Annuel' : 'Mensuel' }}</div>
      </div>
      <!-- Stripe Payment Element ici -->
      <form id="payment-form" @submit.prevent="handleStripePayment">
        <label>
          Email
          <input v-model="email" type="email" required class="mb-4 block border p-2 rounded" />
        </label>
        <div id="payment-element" class="mb-4"></div>
        <button
          :disabled="!stripe || !elements"
          class="!bg-primary hover:!bg-primary-dark text-white font-bold !py-5 px-8 flex justify-center items-center rounded shadow-lg transition w-full"
        >
          Payer {{ total }} €
        </button>
        <div id="error-message" class="text-red-600 mt-2"></div>
      </form>
      <div class="mt-4 text-xs text-gray-500">
        <a href="https://stripe.com/fr/privacy" target="_blank" class="underline">Politique de sécurité Stripe</a>
        <br />
        Aucune donnée bancaire ne transite par nos serveurs (conforme PCI DSS).
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Paiement',
  data() {
    return {
      abonnement: {
        nom: this.$route.query.nom,
        duree: this.$route.query.duree,
        features: this.$route.query.features ? JSON.parse(this.$route.query.features) : [],
        priceMonth: Number(this.$route.query.priceMonth),
        prixTTC: Number(this.$route.query.prixTTC),
        prixHT: Number(this.$route.query.prixHT),
        priceId: this.$route.query.priceId,
      },
      email: this.$route.query.clientEmail || '',
      clientNom: this.$route.query.clientNom || '',
      clientAdresse: this.$route.query.clientAdresse || '',
      stripe: null,
      elements: null,
      clientSecret: null
    };
  },
  computed: {
    total() {
      return this.abonnement.prixTTC;
    }
  },
  async mounted() {
    // 1. Créer le client Stripe côté serveur
    const customerRes = await fetch('/api/create-customer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: this.email,
        name: this.clientNom,
        address: this.clientAdresse
      })
    });
    const customer = await customerRes.json();
    const customerId = customer.id;

    // 2. Récupérer le priceId selon l’offre
    const priceId = this.abonnement.priceId;

    console.log('customerId', customerId, 'priceId', priceId);

    // 3. Créer l’abonnement côté serveur et récupérer le clientSecret
    const subRes = await fetch('/api/create-subscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId,
        priceId
      })
    });
    const subData = await subRes.json();
    if (!subRes.ok) {
      document.getElementById('error-message').textContent = subData.error || "Erreur lors de la création de l'abonnement.";
      return;
    }
    this.clientSecret = subData.clientSecret;
    this.subscriptionId = subData.subscriptionId;

    // 4. Initialiser Stripe.js et Payment Element
    this.stripe = window.Stripe('pk_test_51RRCT0CiTPUVpAF4zknQ9iAS8MZ84I3CYbobKVyDZF0RLi6Svmgs9zGCLDvBeEuRQgS98zWkKjABS7vUPCNPuczq00xCWbO1c2');
    const appearance = { theme: 'stripe' };
    this.elements = this.stripe.elements({ clientSecret, appearance });
    const paymentElement = this.elements.create('payment', { layout: 'tabs' });
    paymentElement.mount('#payment-element');
  },
  methods: {
    async handleStripePayment() {
      if (!this.stripe || !this.elements) {
        document.getElementById('error-message').textContent = "Paiement non prêt, veuillez patienter...";
        return;
      }
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/payment/confirmation?subscriptionId=${this.subscriptionId}`
        }
      });
      if (error) {
        document.getElementById('error-message').textContent = error.message;
      }
    }
  }
};
</script>